module.exports = __webpack_public_path__ + "images/d77e26e109bd70fa7f29156088d5cd5c-MSW_LineArt_Numbers(2)_slide19.png";